import transform from 'lodash/transform';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import isEqual from 'lodash/isEqual';
import isPlainObject from 'lodash/isPlainObject';
import forEach from 'lodash/forEach';
import cloneDeep from 'lodash/cloneDeep';

// borrowd from https://stackoverflow.com/a/46008856
/**
 * Dynamically sets a deeply nested value in an object.
 * Optionally "bores" a path to it if its undefined.
 * @function
 * @param {!object} obj  - The object which contains the value you want to change/set.
 * @param {!array} path  - The array representation of path to the value you want to change/set.
 * @param {!mixed} value - The value you want to set it to.
 * @param {boolean} setrecursively - If true, will set value of non-existing path as well.
 */
export function setDeep(obj, path, value, setrecursively = false) {
    path.reduce((a, b, level) => {
        level = level + 1;
        if (setrecursively && typeof a[b] === 'undefined' && level !== path.length) {
            a[b] = {};
            return a[b];
        }

        if (level === path.length) {
            a[b] = value;
            return value;
        }
        return a[b];
    }, obj);
}

// borrowed from https://davidwells.io/snippets/get-difference-between-two-objects-javascript
/**
 * Find difference between two objects
 * @param  {object} origObj - Source object to compare newObj against
 * @param  {object} newObj  - New object with potential changes
 * @return {object} differences
 */
export function difference(origObj, newObj) {
    function changes(newObj, origObj) {
        let arrayIndexCounter = 0;
        return transform(newObj, function (result, value, key) {
            if (!isEqual(value, origObj[key])) {
                let resultKey = isArray(origObj) ? arrayIndexCounter++ : key;
                result[resultKey] =
                    isObject(value) && isObject(origObj[key])
                        ? changes(value, origObj[key])
                        : value;
            }
        });
    }
    return changes(newObj, origObj);
}

export function flattenObject(obj = {}, separator = '.') {
    const result = {};

    const flatten = (collection, prefix = '', suffix = '') => {
        forEach(collection, (value, key) => {
            const path = `${prefix}${key}${suffix}`;

            if (isArray(value)) {
                flatten(value, `${path}[`, ']');
            } else if (isPlainObject(value)) {
                flatten(value, `${path}${separator}`);
            } else {
                result[path] = value;
            }
        });
    };

    flatten(obj);

    return result;
}

export function flattenedKeys(obj = {}) {
    const clone = cloneDeep(obj);
    const flattened = flattenObject(clone);
    return Object.keys(flattened);
}
